import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  GeneralError1q7afgn844yvi as GeneralError,
  OperationComplete35pb9wj3i5rr0 as OperationComplete,
  ConnectionReEstablishedspo1kq7uvs59 as ConnectionReEstablished,
  NetworkErrorotwtrw4n54or as NetworkError,
  OperationError2sah6hjojh8as as OperationError,
  OperationResponseq42n5mfh87yx as OperationResponse,
  Dispose3n637sa8gbmf1 as Dispose,
  StopOperation41dlmx7s82zc as StopOperation,
  RestartConnection3ucejekzrnll6 as RestartConnection,
  StartOperation372o3p2p9vxt5 as StartOperation,
  Command2ao3eytvqoynn as Command,
  RestartConnection_instancec6o108rka4p4 as RestartConnection_instance,
  Event2qcujbxqrid4f as Event,
  Dispose_instance1ib8cfejdeau as Dispose_instance,
} from './internal/WsMessage.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1 as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancedviv089p54f2 as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { DefaultWebSocketEngine2qlkcxmcddkl7 as DefaultWebSocketEngine } from './JsWebSocketEngine.mjs';
import { Factory2jyzsj2j7cj0z as Factory } from './SubscriptionWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { delay3e2ei0hoxjoud as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { BufferOverflow_SUSPEND_getInstanceob833ibjouyy as BufferOverflow_SUSPEND_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import {
  asSharedFlow2buz3fbrowsyg as asSharedFlow,
  onSubscription3iwvbdmbwg7iq as onSubscription,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Share.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { transformWhile1eyv77fe96rjt as transformWhile } from '../../internal/flows.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$serverUrl$slambda($serverUrl) {
  return constructCallableReference(function *($completion) {
    return $serverUrl;
  }, 0);
}
function WebSocketNetworkTransport$execute$o$collect$slambda($$this$unsafeFlow, $request) {
  return constructCallableReference(function *(value, $completion) {
    var tmp0 = $$this$unsafeFlow;
    $l$block: {
      if (value.n31() === $request.t40_1.toString() || value.n31() == null) {
        yield* tmp0.v1d(value, $completion);
        break $l$block;
      }
    }
    return Unit_instance;
  }, 1);
}
function WebSocketNetworkTransport$execute$o$collect$slambda_0($$this$unsafeFlow, $request, $incrementalResultsMerger, this$0) {
  return constructCallableReference(function *(value, $completion) {
    var $this$transform = $$this$unsafeFlow;
    var tmp;
    if (value instanceof OperationResponse()) {
      var responsePayload = value.g6a_1;
      var requestCustomScalarAdapters = ensureNotNull($request.w40_1.s45(Key_getInstance()));
      var tmp_0;
      if (isDeferred(responsePayload)) {
        tmp_0 = to($incrementalResultsMerger.u64(responsePayload), $incrementalResultsMerger.q64());
      } else {
        tmp_0 = to(responsePayload, null);
      }
      var _destruct__k2r9zo = tmp_0;
      var payload = _destruct__k2r9zo.ze();
      var deferredFragmentIdentifiers = _destruct__k2r9zo.af();
      var apolloResponse = toApolloResponse(jsonReader(payload), $request.s40_1, $request.t40_1, requestCustomScalarAdapters, deferredFragmentIdentifiers);
      if (!$incrementalResultsMerger.r64()) {
        $incrementalResultsMerger.d3o();
      }
      tmp = apolloResponse;
    } else {
      if (value instanceof OperationError()) {
        tmp = errorResponse(this$0, $request, SubscriptionOperationException().o4e($request.s40_1.operationName(), value.e6a_1));
      } else {
        if (value instanceof NetworkError()) {
          tmp = errorResponse(this$0, $request, ApolloNetworkException().d47('Network error while executing ' + $request.s40_1.operationName(), value.b6a_1));
        } else {
          var tmp_1;
          if (value instanceof ConnectionReEstablished()) {
            tmp_1 = true;
          } else {
            var tmp_2;
            if (value instanceof OperationComplete()) {
              tmp_2 = true;
            } else {
              tmp_2 = value instanceof GeneralError();
            }
            tmp_1 = tmp_2;
          }
          if (tmp_1) {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected event ' + toString(value);
            throw IllegalStateException().o(toString(message));
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp$ret$1 = tmp;
    yield* $this$transform.v1d(tmp$ret$1, $completion);
    return Unit_instance;
  }, 1);
}
function WebSocketNetworkTransport$execute$o$collect$slambda_1($$this$unsafeFlow, $incrementalResultsMerger) {
  return constructCallableReference(function *(value, $completion) {
    var tmp0 = $$this$unsafeFlow;
    $l$block: {
      if (!$incrementalResultsMerger.s64()) {
        yield* tmp0.v1d(value, $completion);
        break $l$block;
      }
    }
    return Unit_instance;
  }, 1);
}
function *supervise($this, scope, $completion) {
  var idleJob = {_v: null};
  var connectionJob = {_v: null};
  var protocol = {_v: null};
  var reopenAttemptCount = 0n;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var activeMessages = LinkedHashMap().ec();
  $l$loop_1: while (true) {
    var message = yield* $this.o6a_1.e1b($completion);
    if (isInterface(message, Event())) {
      if (message instanceof NetworkError()) {
        supervise$closeProtocol(protocol, connectionJob, idleJob);
        var tmp0_safe_receiver = $this.m6a_1;
        if ((tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver(message.b6a_1, reopenAttemptCount, $completion))) === true) {
          var _unary__edvuaz = reopenAttemptCount;
          reopenAttemptCount = add(_unary__edvuaz, get_ONE());
          yield* $this.o6a_1.b1b(RestartConnection_instance, $completion);
        } else {
          reopenAttemptCount = 0n;
          $this.p6a_1.f1f(message);
        }
      } else {
        if (message instanceof ConnectionReEstablished()) {
          reopenAttemptCount = 0n;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = activeMessages.w4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            $this.o6a_1.c1b(element);
          }
        } else {
          reopenAttemptCount = 0n;
          $this.p6a_1.f1f(message);
        }
      }
    } else {
      if (isInterface(message, Command())) {
        if (message instanceof Dispose()) {
          supervise$closeProtocol(protocol, connectionJob, idleJob);
          return Unit_instance;
        }
        if (protocol._v == null) {
          if (message instanceof StopOperation()) {
            activeMessages.y4(message.v6a_1.t40_1);
            continue $l$loop_1;
          }
          var tmp;
          try {
            var tmp_0 = yield* $this.h6a_1($completion);
            var tmp_1;
            var tmp0 = $this.i6a_1;
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_2;
              if (isInterface(tmp0, Collection())) {
                tmp_2 = tmp0.n1();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$3 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_0 = tmp0.p1();
              while (_iterator__ex2g4s_0.q1()) {
                var element_0 = _iterator__ex2g4s_0.r1();
                if (element_0.w48_1 === 'Sec-WebSocket-Protocol') {
                  tmp$ret$3 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3) {
              tmp_1 = $this.i6a_1;
            } else {
              tmp_1 = plus($this.i6a_1, new (HttpHeader())('Sec-WebSocket-Protocol', $this.l6a_1.h1()));
            }
            tmp = yield* $this.j6a_1.w6a(tmp_0, tmp_1, $completion);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof Exception()) {
              var e = $p;
              yield* $this.o6a_1.b1b(new (NetworkError())(e), $completion);
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var webSocketConnection = tmp;
          protocol._v = $this.l6a_1.e69(webSocketConnection, $this.u6a_1, scope);
          try {
            yield* ensureNotNull(protocol._v).n69($completion);
          } catch ($p_0) {
            if ($p_0 instanceof Exception()) {
              var e_0 = $p_0;
              protocol._v = null;
              yield* $this.o6a_1.b1b(new (NetworkError())(e_0), $completion);
              continue $l$loop_1;
            } else {
              throw $p_0;
            }
          }
          var tmp_4 = CoroutineStart_UNDISPATCHED_getInstance();
          connectionJob._v = launch(scope, VOID, tmp_4, WebSocketNetworkTransport$supervise$slambda(protocol));
        }
        if (message instanceof StartOperation()) {
          // Inline function 'kotlin.collections.set' call
          var key = message.x6a_1.t40_1;
          activeMessages.x4(key, message);
          ensureNotNull(protocol._v).u69(message.x6a_1);
        } else {
          if (message instanceof StopOperation()) {
            activeMessages.y4(message.v6a_1.t40_1);
            ensureNotNull(protocol._v).b68(message.v6a_1);
          } else {
            if (message instanceof RestartConnection()) {
              yield* $this.o6a_1.b1b(new (ConnectionReEstablished())(), $completion);
            }
          }
        }
        if (activeMessages.n1()) {
          idleJob._v = launch(scope, VOID, VOID, WebSocketNetworkTransport$supervise$slambda_0($this, protocol, connectionJob, idleJob));
        } else {
          var tmp2_safe_receiver = idleJob._v;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.mx();
          }
          idleJob._v = null;
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function errorResponse($this, request, apolloException) {
  var tmp0_requestUuid = request.t40_1;
  var tmp1_operation = request.s40_1;
  return Builder().u41(tmp1_operation, tmp0_requestUuid).z41(apolloException).a42(true).i37();
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.y61_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.z61_1 = ArrayList().p2();
        this.a62_1 = null;
        this.b62_1 = null;
        this.c62_1 = null;
        this.d62_1 = null;
        this.e62_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      l60(serverUrl) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        tmp.y61_1 = WebSocketNetworkTransport$Builder$serverUrl$slambda(serverUrl);
        return this;
      }
      j62(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.y61_1 = serverUrl;
        return this;
      }
      f62(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.a62_1 = webSocketEngine;
        return this;
      }
      g62(idleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.b62_1 = idleTimeoutMillis;
        return this;
      }
      h62(protocolFactory) {
        // Inline function 'kotlin.apply' call
        this.c62_1 = protocolFactory;
        return this;
      }
      i62(reopenWhen) {
        // Inline function 'kotlin.apply' call
        this.d62_1 = reopenWhen;
        return this;
      }
      i37() {
        var tmp0_elvis_lhs = this.y61_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No serverUrl specified';
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp_1 = this.z61_1;
        var tmp1_elvis_lhs = this.a62_1;
        var tmp_2 = tmp1_elvis_lhs == null ? new (DefaultWebSocketEngine())() : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.b62_1;
        var tmp_3 = tmp2_elvis_lhs == null ? 60000n : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = this.c62_1;
        return new (WebSocketNetworkTransport())(tmp_0, tmp_1, tmp_2, tmp_3, tmp3_elvis_lhs == null ? new (Factory())() : tmp3_elvis_lhs, this.d62_1, get_impl(this.e62_1));
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.y6a_1 = function_0;
      }
      *v1d(value, $completion) {
        return yield* this.y6a_1(value, $completion);
      }
      i5() {
        return this.y6a_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function WebSocketNetworkTransport$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/supervise(this$0, $this$launch, $completion);
    return Unit_instance;
  }, 1);
}
var WebSocketNetworkTransport$listener$1Class;
function WebSocketNetworkTransport$listener$1() {
  if (WebSocketNetworkTransport$listener$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.z6a_1 = this$0;
      }
      t69(id, payload) {
        this.z6a_1.o6a_1.c1b(new (OperationResponse())(id, payload));
      }
      s69(id, payload) {
        this.z6a_1.o6a_1.c1b(new (OperationError())(id, payload));
      }
      q69(id) {
        this.z6a_1.o6a_1.c1b(new (OperationComplete())(id));
      }
      r69(payload) {
        this.z6a_1.o6a_1.c1b(new (GeneralError())(payload));
      }
      a6b(cause) {
        this.z6a_1.o6a_1.c1b(new (NetworkError())(cause));
      }
    }
    initMetadataForClass($);
    WebSocketNetworkTransport$listener$1Class = $;
  }
  return WebSocketNetworkTransport$listener$1Class;
}
function supervise$closeProtocol(protocol, connectionJob, idleJob) {
  var tmp0_safe_receiver = protocol._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.l6();
  }
  protocol._v = null;
  var tmp1_safe_receiver = connectionJob._v;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.mx();
  }
  connectionJob._v = null;
  var tmp2_safe_receiver = idleJob._v;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.mx();
  }
  idleJob._v = null;
}
function WebSocketNetworkTransport$supervise$slambda($protocol) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* ensureNotNull($protocol._v).a6a($completion);
    return Unit_instance;
  }, 1);
}
function WebSocketNetworkTransport$supervise$slambda_0(this$0, $protocol, $connectionJob, $idleJob) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.k6a_1, $completion);
    supervise$closeProtocol($protocol, $connectionJob, $idleJob);
    return Unit_instance;
  }, 1);
}
function WebSocketNetworkTransport$execute$slambda(this$0, $request) {
  return constructCallableReference(function *($this$onSubscription, $completion) {
    yield* this$0.o6a_1.b1b(new (StartOperation())($request), $completion);
    return Unit_instance;
  }, 1);
}
var WebSocketNetworkTransport$execute$$inlined$filter$1Class;
function WebSocketNetworkTransport$execute$$inlined$filter$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filter$1Class === VOID) {
    class $ {
      constructor($this, $request) {
        this.b6b_1 = $this;
        this.c6b_1 = $request;
      }
      *u1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda(collector, this.c6b_1);
        yield* this.b6b_1.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filter$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filter$1Class;
}
function WebSocketNetworkTransport$execute$slambda_0($request) {
  return constructCallableReference(function *($this$transformWhile, it, $completion) {
    var tmp;
    if (it instanceof OperationComplete()) {
      tmp = false;
    } else {
      if (it instanceof ConnectionReEstablished()) {
        tmp = false;
      } else {
        if (it instanceof NetworkError()) {
          yield* $this$transformWhile.v1d(it, $completion);
          tmp = false;
        } else {
          if (it instanceof GeneralError()) {
            println('Received general error while executing operation ' + $request.s40_1.operationName() + ': ' + toString_0(it.d6b_1));
            tmp = true;
          } else {
            yield* $this$transformWhile.v1d(it, $completion);
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }, 2);
}
var WebSocketNetworkTransport$execute$$inlined$map$1Class;
function WebSocketNetworkTransport$execute$$inlined$map$1() {
  if (WebSocketNetworkTransport$execute$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, $request, $incrementalResultsMerger, this$0) {
        this.f6b_1 = $this;
        this.g6b_1 = $request;
        this.h6b_1 = $incrementalResultsMerger;
        this.i6b_1 = this$0;
      }
      *u1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_0(collector, this.g6b_1, this.h6b_1, this.i6b_1);
        yield* this.f6b_1.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$map$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$map$1Class;
}
var WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
function WebSocketNetworkTransport$execute$$inlined$filterNot$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filterNot$1Class === VOID) {
    class $ {
      constructor($this, $incrementalResultsMerger) {
        this.j6b_1 = $this;
        this.k6b_1 = $incrementalResultsMerger;
      }
      *u1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_1(collector, this.k6b_1);
        yield* this.j6b_1.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filterNot$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
}
function WebSocketNetworkTransport$execute$slambda_1(this$0, $request) {
  return constructCallableReference(function *($this$onCompletion, it, $completion) {
    yield* this$0.o6a_1.b1b(new (StopOperation())($request), $completion);
    return Unit_instance;
  }, 2);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(serverUrl, headers, webSocketEngine, idleTimeoutMillis, protocolFactory, reopenWhen, incrementalDeliveryProtocolImpl) {
        webSocketEngine = webSocketEngine === VOID ? new (DefaultWebSocketEngine())() : webSocketEngine;
        idleTimeoutMillis = idleTimeoutMillis === VOID ? 60000n : idleTimeoutMillis;
        protocolFactory = protocolFactory === VOID ? new (Factory())() : protocolFactory;
        this.h6a_1 = serverUrl;
        this.i6a_1 = headers;
        this.j6a_1 = webSocketEngine;
        this.k6a_1 = idleTimeoutMillis;
        this.l6a_1 = protocolFactory;
        this.m6a_1 = reopenWhen;
        this.n6a_1 = incrementalDeliveryProtocolImpl;
        this.o6a_1 = Channel(2147483647);
        this.p6a_1 = MutableSharedFlow(0, 2147483647, BufferOverflow_SUSPEND_getInstance());
        this.q6a_1 = asSharedFlow(this.p6a_1);
        this.r6a_1 = this.p6a_1.j1f();
        this.s6a_1 = Dispatchers_getInstance().g13_1.x12(1);
        this.t6a_1 = CoroutineScope(this.s6a_1);
        launch(this.t6a_1, VOID, VOID, WebSocketNetworkTransport$slambda(this));
        var tmp = this;
        tmp.u6a_1 = new (WebSocketNetworkTransport$listener$1())(this);
      }
      s62(request) {
        var incrementalResultsMerger = this.n6a_1.i64();
        // Inline function 'kotlinx.coroutines.flow.filter' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_0 = onSubscription(this.q6a_1, WebSocketNetworkTransport$execute$slambda(this, request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp = new (WebSocketNetworkTransport$execute$$inlined$filter$1())(this_0, request);
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_1 = transformWhile(tmp, WebSocketNetworkTransport$execute$slambda_0(request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        // Inline function 'kotlinx.coroutines.flow.filterNot' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_2 = new (WebSocketNetworkTransport$execute$$inlined$map$1())(this_1, request, incrementalResultsMerger, this);
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp_0 = new (WebSocketNetworkTransport$execute$$inlined$filterNot$1())(this_2, incrementalResultsMerger);
        return onCompletion(tmp_0, WebSocketNetworkTransport$execute$slambda_1(this, request));
      }
      sz() {
        this.o6a_1.c1b(Dispose_instance);
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport', VOID, VOID, VOID, [1]);
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.v4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder3moivcm5iuump,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
